export const EventSideNavs = {
  items: [
    {
      name: "لوحة التحكم",
      url: "/MyticketCinema/EventDashboard",
      icon: "fa fa-tachometer-alt",
    },
    {
      name: "الصفحة الشخصية",
      url: "/MyticketCinema/profile",
      icon: "fas fa-user-cog",
    },
    {
      name: "الرصيد",
      url: "/MyticketCinema/EventAccounting",
      icon: "fas fa-money-bill-wave",
    },
    {
      name: "تذاكر مُباعة",
      url: "/MyticketCinema/ViewTicketsHistoryEvent",
      icon: "fas fa-ticket-alt",
    },
    {
      name: "كاشير",
      url: "/MyticketCinema/ViewCashier",
      icon: "fas fa-user-tag",
    },
    {
      name: "فئات التذاكر",
      url: "/MyticketCinema/Tickets",
      icon: "fas fa-eraser",
    },
    {
      name: "القاعات",
      url: "/MyticketCinema/showHalls",
      icon: "fas fa-hotel",
    },
    {
      name: "الحجوزات",
      url: "/MyticketCinema/ViewReservationEvent",
      icon: "fa fa-university",
    },
    {
      name: "العروض",
      url: "/MyticketCinema/event-shows",
      icon: "fas fa-map",
    },
    // {
    //     name: "الارشيف",
    //     url: "/MyticketCinema/Archive",
    //     icon: "fa fa-trash-alt",
    // },
    {
      name: "التقارير",
      url: "/MyticketCinema/ReportFilteration",
      icon: "fa fa-file",
    },
  ],
};

export const EventSideNavsEn = {
  items: [
    {
      name: "DashBoard",
      url: "/MyticketCinema/EventDashboard",
      icon: "fa fa-tachometer-alt",
    },
    {
      name: " Profile",
      url: "/MyticketCinema/profile",
      icon: "fas fa-user-cog",
    },
    {
      name: " Balance",
      url: "/MyticketCinema/EventAccounting",
      icon: "fas fa-money-bill-wave",
    },
    {
        name: "Tickets sold out",
        url: "/MyticketCinema/ViewTicketsHistoryEvent",
        icon: "fas fa-ticket-alt",
      },
    {
      name: "Cashier",
      url: "/MyticketCinema/ViewCashier",
      icon: "fas fa-user-tag",
    },
    {
      name: "Ticket Category",
      url: "/MyticketCinema/Tickets",
      icon: "fas fa-eraser",
    },
    {
      name: "Halls",
      url: "/MyticketCinema/showHalls",
      icon: "fa fa-university",
    },
    {
      name: "Show",
      url: "/MyticketCinema/event-shows",
      icon: "fas fa-map",
    },
    {
      name: "Reservation",
      url: "/MyticketCinema/ViewReservationEvent",
      icon: "fas fa-ticket-alt",
    },

    // {
    //     name: "Archive",
    //     url: "/MyticketCinema/Archive",
    //     icon: "fa fa-trash-alt",
    // },
    {
      name: "Reports",
      url: "/MyticketCinema/ReportFilteration",
      icon: "fa fa-file",
    },
  ],
};
